/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderSequenceAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class RenderSequenceInternalAPI {

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#startTaskExecution
		 * @description starts a task
		 * @param {Object} taskInfo
		 * @param {Object} taskInfo.taskExecution task execution
		 * @param {BaseTask} taskInfo.task task to execute
		 * @param {Object} taskInfo.renderContext render context
		 * @return {Promise}
		 */
		startTaskExecution() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#resolveTaskExecution
		 * @description resolve a successful task
		 * @param {Object} taskInfo
		 * @param {Object} taskInfo.taskExecution task execution
		 * @param {BaseTask} taskInfo.task task to execute
		 */
		resolveTaskExecution() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#rejectTaskExecution
		 * @description rejects a failed task
		 * @param {Object} taskInfo
		 * @param {Object} taskInfo.taskExecution task execution
		 * @param {BaseTask} taskInfo.task task to execute
		 * @param {Error} task.error error
		 */
		rejectTaskExecution() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#getProvidersRenderStepList
		 * @description Return a merged list of all render steps that were added by the render step providers
		 * @return {RenderStepProvideAPI.RenderStepDefinition[]} renderSteps
		 *
		 */
		getProvidersRenderStepList() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#registerRenderEngine
		 * @description Allow consumer to register expected render engine before trigger render sequence
		 * @param {VisRenderSequence} {@link VisRenderSequence} instance
		 */
		registerRenderEngine() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#triggerRenderSequence
		 * @param {Object} options The render options
		 * @description Trigger the engine.process method with the passed in options
		 * @return {Promise}
		 */
		triggerRenderSequence() {}

		/**
		 * @protected
		 * @function RenderSequenceInternalAPI#getCurrentRenderContext
		 * @param {String} taskId The task identifier
		 * @description Get the current render context for give task id
		 * @return {RenderContextAPI}
		 */
		getCurrentRenderContext() {}
	}

	return RenderSequenceInternalAPI;
});